{
  "bg": {
    "x": 0,
    "y": 0,
    "w": 941,
    "h": 1672
  },
  "logo": {
    "x": 150,
    "y": 109,
    "w": 649,
    "h": 176
  },
  "tabs": {
    "all.idle": {
      "x": 29,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "all.selected": {
      "x": 29,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "meet.idle": {
      "x": 250,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "meet.selected": {
      "x": 250,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "flirt.idle": {
      "x": 470,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "flirt.selected": {
      "x": 470,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "special.idle": {
      "x": 688,
      "y": 286,
      "w": 225.5,
      "h": 106
    },
    "special.selected": {
      "x": 688,
      "y": 286,
      "w": 225.5,
      "h": 106
    }
  },
  "tabBody": {
    "all": {
      "x": 36,
      "y": 303,
      "w": 211,
      "h": 72
    },
    "meet": {
      "x": 260,
      "y": 303,
      "w": 205,
      "h": 72
    },
    "flirt": {
      "x": 479,
      "y": 303,
      "w": 207,
      "h": 72
    },
    "special": {
      "x": 697,
      "y": 303,
      "w": 207,
      "h": 72
    }
  },
  "cards": {
    "friends": {
      "dx": -6.5,
      "dy": -4,
      "w": 891.5,
      "h": 240
    },
    "meet": {
      "dx": -9,
      "dy": -5,
      "w": 891.5,
      "h": 241
    },
    "flirt": {
      "dx": -8.5,
      "dy": -4,
      "w": 891.5,
      "h": 240
    },
    "date": {
      "dx": -7.5,
      "dy": -5,
      "w": 891.5,
      "h": 241
    }
  },
  "card": {
    "w": 879,
    "h": 232,
    "x": 30,
    "firstY": 398,
    "pitch": 250,
    "image": {
      "x": 0,
      "y": 0,
      "w": 348,
      "h": 232
    },
    "text": {
      "x": 352,
      "w": 250
    },
    "divider": 616,
    "pill": {
      "x": 617,
      "y": 125,
      "w": 240,
      "h": 85
    }
  },
  "sticky": {
    "x": 0,
    "y": 1202,
    "w": 941,
    "h": 470.5
  },
  "pwf": {
    "x": 146,
    "y": 1511.5,
    "w": 651,
    "h": 145,
    "body": {
      "x": 154,
      "y": 1522,
      "w": 635,
      "h": 123
    }
  },
  "cardLogos": {
    "friends": {
      "w": 250,
      "h": 144
    },
    "meet": {
      "w": 250,
      "h": 145.5
    },
    "flirt": {
      "w": 250,
      "h": 146
    },
    "date": {
      "w": 250,
      "h": 150
    }
  }
}
